import { useQuery } from "@tanstack/react-query";
import { SearchFunctions } from "@graylog/server-api";
const fetchAggregationFunctions = () => SearchFunctions.functions();
const useAggregationFunctions = () => useQuery({
  queryKey: ["aggregationFunctions"],
  queryFn: fetchAggregationFunctions
});
export default useAggregationFunctions;
